
import * as Comlink from "comlink";

/**
 * @param {MessagePort} port
 * @param {object} initialState
 */
function newBridge(port, initialState) {
    return {
        expose: object => Comlink.expose(object, port),
        wrap: () => Comlink.wrap(port),
        initialState,
    };
}

/**
 * @param {Set<string>} allowedOrigins
 * @returns {Promise}
 */
export function acceptWindowConnection(allowedOrigins) {

    // parent posts:
    //    {api: "net.nullschool.earth", version: 1, action: "connect", id: "abc123"} to the iframe
    // parent receives:
    //    {api, version, action, id, success: true, result: "connected"} and a MessagePort
    // or receives:
    //    {api, version, action, id, success: false, result: "unknown api/version"}

    return new Promise(resolve => {

        function accept({data, origin, source}) {
            if (!allowedOrigins.has(origin)) {
                return;
            }
            const {api, version, action, id, initialState} = data ?? {};
            if (api !== "net.nullschool.earth" && api !== "earth") {  // UNDONE: remove "earth" when ready
                return;  // this message isn't for earth
            }
            if (version !== 1 || action !== "connect") {
                const response = {api, version, action, id, success: false, result: "unknown api/version"};
                return source.postMessage(response, origin);
            }

            const {port1, port2} = new MessageChannel();
            const response = {api, version, action, id, success: true, result: "connected"};
            source.postMessage(response, origin, [port2]);
            window.removeEventListener("message", accept);

            resolve(newBridge(port1, initialState));
        }

        window.addEventListener("message", accept);
    });
}
